// Platform resolves: .web.tsx on web, .tsx on RN.
import RefreshIcon from './RefreshIcon'

export default RefreshIcon
